import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RootState } from '../../../../../store';
import { ShopState } from '../service/shop.interface';
import { shopsApi } from '../service/shops';

const initialState: ShopState = {
    id: null,
    name: '',
    about: '',
    buyable: false,
    photo: '',
    price_from: false,
    user_id: null,
    shop_inline: '',
    shop_link: '',
    payment_system: null,
    type: 0,
    details: {
        contact_info: '',
        config: '',
        integration_email: '',
        policy: '',
        offer: '',
    },
    list: [],
    legal_info: null,
    current: null,
};

export const shopSlice = createSlice({
    name: 'shop',
    initialState,
    reducers: {
        setShopCurrent(state, action) {
            state.current = action.payload;
        },
        setShopList(state, action) {
            const newItems = action.payload.filter(
                item => !state.list.some(existing => existing.id === item.id)
            );
            state.list = [...state.list, ...newItems];
        },
    },
    extraReducers: builder => {
        builder.addMatcher(
            shopsApi.endpoints.readShopById.matchFulfilled,
            (state, { payload }) => {
                Object.assign(state, {
                    ...state,
                    ...payload,
                });
            }
        );
    },
});

export const getShopState = (state: RootState): ShopState => state.shop;
export const selectShopCurrent = (state: RootState): ShopState['current'] =>
    state.shop.current;
export const { setShopCurrent, setShopList } = shopSlice.actions;

const persistConfig = {
    key: 'shop',
    storage,
    whitelist: ['details, legal_info'],
};

export const shopReducer = persistReducer(persistConfig, shopSlice.reducer);
